// shared seed data for the social scaffolding (still local until phase 3
// when we move users + logs to the api). show data lives in mongo now.

export const REACTION_TAGS = [
  "loved it","worth seeing","still thinking about it","messy but alive","not for me",
  "go before it closes","bring a friend","bring an enemy","gorgeous design","too long",
  "underseen","overhyped","made me cry","made me want to make theatre","i have notes",
  "the room did the dramaturgy","felt haunted","credits incomplete",
];

export const isCreditsIncomplete = (show) => {
  if (!show) return false;
  const ts = (show.teamStatus || "").toLowerCase();
  return (
    ts.includes("incomplete") ||
    ts.includes("needs programme pull") ||
    ts.includes("needs cleanup") ||
    (show.creativeTeam || []).length === 0 ||
    (show.cast || []).length === 0
  );
};

// seeded fake users (still local — phase 3 will replace with real users from api)
export const SEED_USERS = [
  { id: "u-diorthemis",       handle: "diorthemis",      displayName: "@diorthemis",      bio: "ushers' usher",                followers: 412,  followingCount: 187 },
  { id: "u-plumb",             handle: "plumb",           displayName: "@plumb",           bio: "downtown only",                followers: 268,  followingCount: 94  },
  { id: "u-stagedoor-barb",    handle: "stagedoor.barb",  displayName: "@stagedoor.barb",  bio: "i sit through everything",     followers: 1893, followingCount: 312 },
  { id: "u-philip-was-here",   handle: "philip.was.here", displayName: "@philip.was.here", bio: "",                              followers: 87,   followingCount: 41  },
  { id: "u-treadboards",       handle: "treadboards",     displayName: "@treadboards",     bio: "",                              followers: 156,  followingCount: 122 },
  { id: "u-indie-ushers",      handle: "indie.ushers",    displayName: "@indie.ushers",    bio: "smaller rooms",                followers: 743,  followingCount: 201 },
  { id: "u-curtaincall-k",     handle: "curtaincall.k",   displayName: "@curtaincall.k",   bio: "",                              followers: 312,  followingCount: 78  },
  { id: "u-two4one",           handle: "two4one",         displayName: "@two4one",         bio: "honest takes only",            followers: 524,  followingCount: 163 },
];

export const SELF_FOLLOWER_COUNT = 23;

export const getUser = (id) => SEED_USERS.find((u) => u.id === id);

const SEED_HANDLE_TO_USER = {
  "@diorthemis": "u-diorthemis",
  "@plumb": "u-plumb",
  "@stagedoor.barb": "u-stagedoor-barb",
  "@philip.was.here": "u-philip-was-here",
  "@treadboards": "u-treadboards",
  "@indie.ushers": "u-indie-ushers",
  "@curtaincall.k": "u-curtaincall-k",
  "@two4one": "u-two4one",
};

const SEED_STAR_OVERRIDES = {
  a1: 4, a2: 4.5, a3: 3.5, a4: 4, a5: 4, a6: 3.5, a7: 4.5, a8: 2.5,
};

// fake seeded activity (still local — phase 3 will replace with real logs)
export const SEED_ACTIVITY = [
  { id: "a1", showId: "mary-mary-mary-mary-2026", who: "@diorthemis", note: "messy but alive in the best way. ellen mcdougall let it breathe.", date: "2 days ago" },
  { id: "a2", showId: "mary-mary-mary-mary-2026", who: "@plumb", note: "amaka umeh again. always.", date: "5 days ago" },
  { id: "a3", showId: "the-seagull-2026", who: "@stagedoor.barb", note: "chekhov but the chairs are doing the most.", date: "1 week ago" },
  { id: "a4", showId: "clydes-2026", who: "@philip.was.here", note: "philip akin's blocking is a love letter.", date: "3 days ago" },
  { id: "a5", showId: "the-division-2026", who: "@treadboards", note: "this room did the dramaturgy.", date: "yesterday" },
  { id: "a6", showId: "knife-2026", who: "@indie.ushers", note: "stagepunk is doing things downtown is not ready for.", date: "4 days ago" },
  { id: "a7", showId: "a-strange-loop-2026", who: "@curtaincall.k", note: "the extension is the right call. malachi is unreal.", date: "6 days ago" },
  { id: "a8", showId: "moulin-rouge-2026", who: "@two4one", note: "fine. fine. fine. it's fine.", date: "1 week ago" }
];

// post-process seed activity for v1.7 (must come AFTER SEED_ACTIVITY declaration)
SEED_ACTIVITY.forEach((a) => {
  if (a.who && !a.userId) a.userId = SEED_HANDLE_TO_USER[a.who] || null;
  if (a.visibility === undefined) a.visibility = "public";
  if (a.hasSpoilers === undefined) a.hasSpoilers = false;
  if (a.stars === undefined) a.stars = SEED_STAR_OVERRIDES[a.id] ?? null;
});
